import { useLocation } from "react-router-dom";

export const useRouteQuery = (queryName: string) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const value = params.get(queryName);
  return value;
};
